import { useEffect, useState } from "react";
import { apiRequest } from "../../network/apiClient";
import {API_ENDPOINTS} from "../../api/apiEndpoints";

export const useAccDetRelated = ({lead_id}) => {
    const [infoGathering, setInfoGathering] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        if (!lead_id) return;
        setLoading(true);
        try{
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_LEADS.INFO_GATHERING}?lead_id=${lead_id}`, 'GET')
            setInfoGathering(result);

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, [lead_id]);

    return {infoGatheringAPI: infoGathering, loading, refetch: fetchData};
}
